// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var List = require("rescript/lib/js/list.js");
var $$Array = require("rescript/lib/js/array.js");
var Curry = require("rescript/lib/js/curry.js");
var React = require("react");
var $$String = require("rescript/lib/js/string.js");
var Js_dict = require("rescript/lib/js/js_dict.js");
var Belt_Int = require("rescript/lib/js/belt_Int.js");
var Js_promise = require("rescript/lib/js/js_promise.js");
var Caml_format = require("rescript/lib/js/caml_format.js");
var Caml_option = require("rescript/lib/js/caml_option.js");
var Json_decode = require("@glennsl/bs-json/src/Json_decode.res.js");
var Querystringify = require("querystringify");
var JsxRuntime = require("react/jsx-runtime");
var RescriptReactRouter = require("@rescript/react/src/RescriptReactRouter.res.js");
var Http$ReactHooksTemplate = require("../common/http.res.js");
var Filters$ReactHooksTemplate = require("../dashboard/filters/filters.res.js");
var Loading$ReactHooksTemplate = require("../dashboard/dashboard/Loading.res.js");
var Pagination$ReactHooksTemplate = require("../common/Pagination.res.js");
var PaginationUtils$ReactHooksTemplate = require("../common/PaginationUtils.res.js");

function emptyState(param) {
  return {
          header: /* [] */0,
          contents: /* [] */0
        };
}

function noMessage(param) {
  return "";
}

function decodeDownloadReport(json) {
  return Json_decode.field("file_name", Json_decode.string, json);
}

function decodeReportDetails(header, json) {
  return List.map((function (name) {
                return Json_decode.optional((function (param) {
                              return Json_decode.field(name, Json_decode.string, param);
                            }), json);
              }), header);
}

function decode(json) {
  var header = Json_decode.field("header", (function (param) {
          return Json_decode.list(Json_decode.string, param);
        }), json);
  return {
          header: header,
          contents: Json_decode.field("report", (function (param) {
                  return Json_decode.list((function (param) {
                                return decodeReportDetails(header, param);
                              }), param);
                }), json)
        };
}

var Report = {
  emptyState: emptyState,
  noMessage: noMessage,
  decodeDownloadReport: decodeDownloadReport,
  decodeReportDetails: decodeReportDetails,
  decode: decode
};

var emptyReports = {
  header: /* [] */0,
  contents: /* [] */0
};

var initialState = {
  loading: true,
  reports: emptyReports,
  toggleFilter: false
};

function reducer(state, x) {
  if (typeof x !== "object") {
    if (x === "FetchReportsInProgress") {
      return {
              loading: true,
              reports: state.reports,
              toggleFilter: state.toggleFilter
            };
    } else {
      return {
              loading: state.loading,
              reports: state.reports,
              toggleFilter: !state.toggleFilter
            };
    }
  } else {
    return {
            loading: false,
            reports: x._0,
            toggleFilter: state.toggleFilter
          };
  }
}

function totalRecord(x) {
  if (x !== undefined) {
    return x;
  } else {
    return "1";
  }
}

function perPage(x) {
  if (x !== undefined) {
    return x;
  } else {
    return "1";
  }
}

var emptyPageInfo = {
  total: "1",
  perPage: "1"
};

function QuickSurveyReport(props) {
  var match = React.useReducer(reducer, initialState);
  var dispatch = match[1];
  var state = match[0];
  var match$1 = React.useState(function (param) {
        return emptyPageInfo;
      });
  var setPageInfo = match$1[1];
  var pageInfo = match$1[0];
  var queryParams = Querystringify.parse(props.search);
  var x = Js_dict.get(queryParams, "page");
  var currentPage;
  if (x !== undefined && x !== "") {
    var page = Belt_Int.fromString(x);
    currentPage = page !== undefined ? page : 1;
  } else {
    currentPage = 1;
  }
  var url = "/api/v1/quick_survey_report?page=" + String(currentPage);
  var handlePageChange = function (pageNumber) {
    RescriptReactRouter.push("/quick_survey/report/?page=" + String(pageNumber));
  };
  var fetchReport = function (param) {
    return Js_promise.then_((function (param) {
                  var headers = param[0];
                  var x = headers.get("Total");
                  var total = x !== null ? (
                      x === null ? undefined : Caml_option.some(x)
                    ) : "1";
                  var x$1 = headers.get("Per-Page");
                  var perPage = x$1 !== null ? (
                      x$1 === null ? undefined : Caml_option.some(x$1)
                    ) : "1";
                  var report = Js_promise.then_((function (json) {
                          return Promise.resolve(Json_decode.field("report", decode, json));
                        }), param[1]);
                  return Promise.resolve([
                              report,
                              [
                                total,
                                perPage
                              ]
                            ]);
                }), Http$ReactHooksTemplate.fetchGetJSONWithHeader(url));
  };
  var onApplyFilter = function (param) {
    Curry._1(dispatch, "ToggleFilter");
    Curry._1(dispatch, "FetchReportsInProgress");
    Js_promise.then_((function (param) {
            var pageInfo = param[1];
            var perPage = pageInfo[1];
            var total = pageInfo[0];
            Curry._1(setPageInfo, (function (param) {
                    return {
                            total: total,
                            perPage: perPage
                          };
                  }));
            Js_promise.then_((function (report) {
                    return Promise.resolve(Curry._1(dispatch, {
                                    TAG: "FetchReportsCompleted",
                                    _0: report
                                  }));
                  }), param[0]);
            return Promise.resolve();
          }), fetchReport());
  };
  var toggleFilter = function (param) {
    Curry._1(dispatch, "ToggleFilter");
  };
  React.useEffect((function (param) {
          Curry._1(dispatch, "FetchReportsInProgress");
          Js_promise.then_((function (param) {
                  var pageInfo = param[1];
                  var perPage = pageInfo[1];
                  var total = pageInfo[0];
                  Curry._1(setPageInfo, (function (param) {
                          return {
                                  total: total,
                                  perPage: perPage
                                };
                        }));
                  Js_promise.then_((function (report) {
                          return Promise.resolve(Curry._1(dispatch, {
                                          TAG: "FetchReportsCompleted",
                                          _0: report
                                        }));
                        }), param[0]);
                  return Promise.resolve();
                }), fetchReport());
        }), [currentPage]);
  var totalCount = Caml_format.int_of_string(pageInfo.total);
  var perPageCount = Caml_format.int_of_string(pageInfo.perPage);
  var totalPagesCount = PaginationUtils$ReactHooksTemplate.totalPages(totalCount, perPageCount);
  return JsxRuntime.jsxs(JsxRuntime.Fragment, {
              children: [
                state.toggleFilter ? JsxRuntime.jsx(Filters$ReactHooksTemplate.make, {
                        onClose: toggleFilter,
                        onApply: onApplyFilter,
                        showDateFilter: false,
                        showFilterPills: false
                      }) : JsxRuntime.jsx(JsxRuntime.Fragment, {}),
                state.loading ? JsxRuntime.jsx("div", {
                        children: JsxRuntime.jsx(Loading$ReactHooksTemplate.make, {
                              text: "Loading Survey..."
                            }),
                        className: "h-screen w-full animated fadeIn"
                      }) : JsxRuntime.jsx(JsxRuntime.Fragment, {
                        children: Caml_option.some(JsxRuntime.jsxs("div", {
                                  children: [
                                    JsxRuntime.jsx("div", {
                                          children: JsxRuntime.jsx("h2", {
                                                children: "Campaign Report",
                                                className: "mb-32-px text-2xl"
                                              }),
                                          className: "flex justify-between items-center mb-30-px "
                                        }),
                                    JsxRuntime.jsx(Pagination$ReactHooksTemplate.Bar.make, {
                                          currentPage: currentPage,
                                          totalPages: totalPagesCount,
                                          totalRecords: totalCount,
                                          perPage: perPageCount,
                                          handlePageChange: handlePageChange,
                                          itemLabel: "records",
                                          className: "mb-4"
                                        }),
                                    JsxRuntime.jsxs("table", {
                                          children: [
                                            JsxRuntime.jsx("thead", {
                                                  children: JsxRuntime.jsx("tr", {
                                                        children: $$Array.of_list(List.mapi((function (i, header) {
                                                                    return JsxRuntime.jsx("th", {
                                                                                children: $$String.capitalize_ascii(header),
                                                                                className: "text-left font-extralight py-10-px pl-4"
                                                                              }, String(i));
                                                                  }), state.reports.header))
                                                      }),
                                                  className: "border border-gray-400 bg-ghostwhite text-aurometalsaurus rounded-t-lg"
                                                }),
                                            JsxRuntime.jsx("tbody", {
                                                  children: $$Array.of_list(List.mapi((function (i, x) {
                                                              return JsxRuntime.jsx("tr", {
                                                                          children: $$Array.of_list(List.mapi((function (k, step) {
                                                                                      if (step !== undefined) {
                                                                                        return JsxRuntime.jsx("td", {
                                                                                                    children: step,
                                                                                                    className: "py-10-px pl-4"
                                                                                                  }, String(k));
                                                                                      } else {
                                                                                        return JsxRuntime.jsx("td", {
                                                                                                    children: "",
                                                                                                    className: "py-10-px pl-4"
                                                                                                  }, String(k));
                                                                                      }
                                                                                    }), x))
                                                                        }, String(i));
                                                            }), state.reports.contents)),
                                                  className: "border border-gray-400"
                                                })
                                          ],
                                          className: "w-full mb-10-px "
                                        })
                                  ],
                                  className: "p-20-px"
                                }))
                      })
              ]
            });
}

var noMessage$1 = "";

var make = QuickSurveyReport;

exports.Report = Report;
exports.emptyReports = emptyReports;
exports.initialState = initialState;
exports.reducer = reducer;
exports.totalRecord = totalRecord;
exports.perPage = perPage;
exports.emptyPageInfo = emptyPageInfo;
exports.noMessage = noMessage$1;
exports.make = make;
/* react Not a pure module */
